module.exports = __webpack_public_path__ + "icomoon.svg?b211dfaec16ef4430470b60ecdb2efa8";